import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ResetPasswordForm from './ResetPasswordForm';

const SendResetLink = ({ isRequestPending, onSubmit, queryString }) => (
    <section>
        <p>
            If you verified your mobile number, enter it below for the fastest password
            reset option. No mobile number? Enter the email address you used to set
            up your hStream ID.
        </p>
        <ResetPasswordForm
            isRequestPending={isRequestPending}
            onSubmit={onSubmit}
        />
        <hr />
        <section className="d-flex align-items-center">
            <span style={{ marginRight: '.5em' }}>Ready to sign in?</span>
            <Link
                to={{
                    pathname: '/login',
                    search: queryString,
                }}
                tabIndex={isRequestPending ? -1 : 0}
                aria-disabled={isRequestPending || undefined}
                onClick={(e) => {
                    if (isRequestPending) e.preventDefault();
                }}
            >
                Sign In
            </Link>
        </section>
    </section>
);

export default SendResetLink;

SendResetLink.propTypes = {
    isRequestPending: PropTypes.bool,
    onSubmit: PropTypes.func,
    queryString: PropTypes.string,
};

SendResetLink.defaultProps = {
    isRequestPending: false,
    onSubmit: undefined,
    queryString: undefined,
};
